import { Navigate } from 'react-router-dom';
import UnauthorizedPage from '../pages/UnauthorizedPage';

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  // Check if the token is valid and if the user's role is allowed to access the route
  if (!token || !role) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <UnauthorizedPage />;
  }

  return children;
};

export default PrivateRoute;
